module.exports = __webpack_public_path__ + "media/assets/images/blog/quite_quitting-small-96bfc5ae55e30f2df123e46ac8d0b753.png";